import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  GetDocumentsDocTypeEnum,
  GetSurveySurveyCodeEnum,
  SessionStateEnum,
} from "../../orchestrator-api-client";
import { ThunkApi } from "../store.ts";
import { getOffers } from "./get-offers.action.ts";
import { getAdvQuestionnaires } from "./get-adv-questionnaires.action.ts";
import { getCoherenceQuestionnaireData } from "./get-coherence-questionnaire-data.action.ts";
import { getDocumentsList } from "./get-documents-list.action.ts";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";
import { getConfig } from "./get-config.action.ts";

const setSessionState = createAsyncThunk<
  SessionStateEnum,
  SessionStateEnum,
  ThunkApi
>("setSessionState", async (state, { dispatch, rejectWithValue }) => {
  try {
    switch (state) {
      case SessionStateEnum.Cpi:
      case SessionStateEnum.Offer:
        await dispatch(getConfig());
        await dispatch(getOffers());
        break;
      case SessionStateEnum.Adv:
        await dispatch(
          getAdvQuestionnaires({
            surveyCode: GetSurveySurveyCodeEnum.Adeguataverifica,
          }),
        );
        break;
      case SessionStateEnum.CpiQuestionnaire:
        await dispatch(
          getCoherenceQuestionnaireData({
            surveyCode: GetSurveySurveyCodeEnum.AdegAssic,
          }),
        );
        break;
      case SessionStateEnum.Payroll:
        await dispatch(getDocumentsList(GetDocumentsDocTypeEnum.Payrolls));
        break;
      case SessionStateEnum.AccountStatement:
        await dispatch(
          getDocumentsList(GetDocumentsDocTypeEnum.AccountStatement),
        );
        break;
    }

    return state;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Errore Generico",
      description:
        "Puoi riprovare a caricare la pagina o contattare il supporto.",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});

export default setSessionState;
